module.exports = __webpack_public_path__ + "img/pmsm2_.14adf322.png";